import { render, staticRenderFns } from "./AutoprovisioningConfigDisplay.vue?vue&type=template&id=56299096&scoped=true"
import script from "./AutoprovisioningConfigDisplay.vue?vue&type=script&lang=js"
export * from "./AutoprovisioningConfigDisplay.vue?vue&type=script&lang=js"
import style0 from "./AutoprovisioningConfigDisplay.vue?vue&type=style&index=0&id=56299096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56299096",
  null
  
)

export default component.exports